var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_722",
    "data-name": "Group 722",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_374",
    "data-name": "Rectangle 374",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12775",
    "data-name": "Path 12775",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15",
    fill: "#7c97c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12776",
    "data-name": "Path 12776",
    d: "M19.562,24.409H10.438a1.221,1.221,0,0,1-.964-1.969L15.246,15,9.474,7.559a1.22,1.22,0,0,1,.964-1.968h9.124a1.22,1.22,0,0,1,1.191,1.486l-.4,1.787a.771.771,0,1,1-1.5-.336l.311-1.395H11.094l5.523,7.119a1.222,1.222,0,0,1,0,1.5l-5.523,7.119h8.067l-.311-1.4a.771.771,0,1,1,1.5-.335l.4,1.788a1.22,1.22,0,0,1-1.191,1.486m-.314-1.151h0Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTotal);
export default __webpack_public_path__ + "static/media/icon-total.d7538e60b970d6fd24b8f2045977b70f.svg";
export { ForwardRef as ReactComponent };